import { createSimpleFunctional } from '@/util'

export const VCardTitle = createSimpleFunctional('v-card-title')
